// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DZe_","field":"styles_field__AzPJj","fieldCol":"styles_fieldCol__3SjSJ","diffCol":"styles_diffCol__2-oyh","diff":"styles_diff__jJJC8"};